import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import translations from './translations';

const SwitchedTenantDialog = () => {
  const handleRefreshSession = () => {
    window.location.reload();
  };

  return (
    <Dialog open disableBackdropClick disableEscapeKeyDown>
      <DialogTitle id="tenant-switched-title">
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage {...translations.message} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRefreshSession} color="primary">
          <FormattedMessage {...translations.actions.ok} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SwitchedTenantDialog;
